import { createSlice } from "@reduxjs/toolkit";

export const appHelpersSlice = createSlice({
  name: "appHelpers",
  initialState: {
    appBarTitle: "",
    showFilters: false,
    appBarContent: <></>,
    appBarMobileContent: [],
    exportedPdfTarget: { show: false, pdfOptions: {} },
    isOrdering: false,
  },
  reducers: {
    setAppBarTitle: (state, action) => {
      state.appBarTitle = action.payload;
    },
    toggleShowFilters: (state) => {
      state.showFilters = !state.showFilters;
    },
    setShowFilters: (state, action) => {
      state.showFilters = action.payload;
    },
    setAppBarContent: (state, action) => {
      state.appBarContent = action.payload;
    },
    setAppBarMobileContent: (state, action) => {
      state.appBarMobileContent = action.payload;
    },
    setExportedPdfTarget: (state, action) => {
      state.exportedPdfTarget = {
        ...state.exportedPdfTarget,
        ...action.payload,
      };
    },
    setIsOrdering: (state, action) => {
      state.isOrdering = action.payload;
    },
  },
});

export const {
  setAppBarTitle,
  toggleShowFilters,
  setShowFilters,
  setAppBarContent,
  setAppBarMobileContent,
  setExportedPdfTarget,
  setIsOrdering,
} = appHelpersSlice.actions;
export default appHelpersSlice.reducer;
